<fc-search-input
  [label]="label || 'YEAR_MONTH.LABEL' | translate"
  [control]="control"
  [isLocationInput]="true"
  [search]="search"
  [displayWith]="displayWith"
  [showSearchIcon]="showSearchIcon"
  [requiredMark]="requiredMark"
  [preloadOptions]="true"
  [searchOnFocus]="true"
  [translateErrorPrefix]="translateErrorPrefix"
  [enableInfiniteScroll]="true"
></fc-search-input>
